<template>
  <div class="product">
    <div class="product-list">
      <div class="product-main">
        <div class="top-header">
          <div class="left-div">
            <div class="left-1">
              <img src="~@/assets/images/yxsc/3.png" alt="" />
              <img src="~@/assets/images/yxsc/2.png" alt="" />
              <img src="~@/assets/images/yxsc/4.png" alt="" />
            </div>
            <img class="left-2" src="~@/assets/images/yxsc/1.png" alt="" />
          </div>
          <div class="right-div">
            <h2>仙玉</h2>
            <p>游戏内通用货币，可用于购买礼包货币等物品</p>
            <div class="sj-div">
              <p>售价：<span>10仙玉=1元</span></p>
            </div>
            <div class="list-div">
              <p>选择套餐：</p>
              <div class="lists">
                <span
                  v-for="item in products"
                  :class="{ active: activenum == item.id }"
                  @click="handleProducts(item)"
                  >{{ item.text }}</span
                >
              </div>
            </div>
            <div class="list-div">
              <p>数量：</p>
              <div class="lists-num">
                <span @click="handleNumSub">
                  <img src="~@/assets/images/yxsc/9-.png" alt="" />
                </span>
                <p>{{ num }}</p>
                <span @click="handleNumAdd">
                  <img src="~@/assets/images/yxsc/9+.png" alt="" />
                </span>
              </div>
            </div>
            <div class="list-div">
              <p>选择平台：</p>
              <div
                class="lists-num"
                @click="handleOpenPlatform"
                v-clickoutside="handlePlatformClickOutside"
              >
                <p>{{ platformName }}</p>
                <span>
                  <img src="~@/assets/images/yxsc/10.png" alt="" />
                </span>
                <div v-show="showPlatform" class="list-box">
                  <div
                    class="list"
                    v-for="item in platformList"
                    :class="{ active: platformId == item.id }"
                    @click="handlePlatform(item)"
                  >
                    {{ item.text }}
                  </div>
                </div>
              </div>
            </div>
            <div class="list-div">
              <p>选择区服：</p>
              <div
                class="lists-num"
                @click="handleOpenServer"
                v-clickoutside="handleServerClickOutside"
              >
                <p>{{ serverName }}</p>
                <span>
                  <img src="~@/assets/images/yxsc/10.png" alt="" />
                </span>
                <div v-show="showServer" class="list-box">
                  <div
                    class="list"
                    v-for="item in serverList"
                    :class="{ active: serverId == item.id }"
                    @click="handleServer(item)"
                  >
                    {{ item.text }}
                  </div>
                </div>
              </div>
            </div>
            <div class="list-div">
              <p>选择角色：</p>
              <div
                class="lists-num"
                @click="handleOpenRole"
                v-clickoutside="handleRoleClickOutside"
              >
                <p>{{ roleName }}</p>
                <span>
                  <img src="~@/assets/images/yxsc/10.png" alt="" />
                </span>
                <div v-show="showRole" class="list-box">
                  <div
                    class="list"
                    v-for="item in roleList"
                    :class="{ active: roleId == item.id }"
                    @click="handleRole(item)"
                  >
                    {{ item.text }}
                  </div>
                </div>
              </div>
            </div>
            <div class="but-div">
              <div class="but-box" @click="handleBuy">立即购买</div>
              <div
                class="but-box2"
                :class="{ active: isAddCart }"
                @click="handleAddCart"
              >
                {{ isAddCart ? "已加入购物车" : "加入购物车" }}
              </div>
            </div>
          </div>
        </div>
        <div class="title-box">商品介绍</div>
        <div class="product-text-div">
          <div class="text-div-list">
            <span><em>商品名称：</em></span>
            <p>仙玉</p>
          </div>
          <div class="text-div-list">
            <span><em>商品用途：</em></span>
            <p>
              用于《奇门飞花令》游戏中，购买礼包、法宝碎片、金币等物品。
            </p>
          </div>
          <div class="text-div-list">
            <span><em>购买方式：</em></span>
            <p>
              选择好您需要购买的套餐及数量后，在下方选择你所在游戏的平台、区服、角色，付款完成后，商品将在5分钟之内到账您的游戏账号中，请您主要查收
              ！
            </p>
          </div>
          <div class="text-div-list">
            <span><em>购买须知：</em></span>
            <p>
              1.购买商品时，请认真选择您需要充值的账号、角色,以免误发，引起您不必要的损失；<br />2.如未到账，请您立刻咨询游戏中在线客服为您解决问题；
            </p>
          </div>
          <img class="img" src="~@/assets/images/yxsc/img1.png" alt="" />
          <img class="img" src="~@/assets/images/yxsc/img2.png" alt="" />
        </div>
      </div>
    </div>

    <payTypeChoose
      v-if="showPayTypeChoose"
      @closePayTypeChoose="closePayTypeChoose"
    ></payTypeChoose>
  </div>
</template>

<script>
import payTypeChoose from "./payTypeChoose.vue";
export default {
  components: {
    payTypeChoose,
  },
  data() {
    return {
      num: 1,
      platformName: "选择平台",
      platformList: [
        { id: 1, text: "Android" },
        { id: 2, text: "IOS" },
      ],
      platformId: -1,
      showPlatform: false,
      serverName: "选择区服",
      serverList: [
        { id: 1, text: "S001" },
        { id: 2, text: "S002" },
        { id: 3, text: "S003" },
        { id: 4, text: "S004" },
      ],
      serverId: -1,
      showServer: false,
      roleName: "选择角色",
      roleList: [{ id: 1, text: "小李白" }],
      roleId: -1,
      showRole: false,
      resDatas: "",
      products: [
        { id: 1, text: "50仙玉=5元" },
        { id: 2, text: "60仙玉=6元" },
        { id: 3, text: "120仙玉=12元" },
        { id: 4, text: "450仙玉=45元" },
        { id: 5, text: "600仙玉=60元" },
        { id: 6, text: "1900仙玉=190元" },
        { id: 7, text: "3480仙玉=348元" },
        { id: 8, text: "6480仙玉=648元" },
      ],
      activenum: 1,
      isAddCart: false,
      showPayTypeChoose: false,
    };
  },
  methods: {
    handleProducts(info) {
      this.activenum = info.id;
    },
    handleNumSub() {
      this.num = Math.max(--this.num, 1);
    },
    handleNumAdd() {
      this.num++;
    },
    handleOpenPlatform() {
      this.showPlatform = !this.showPlatform;
    },
    handlePlatformClickOutside() {
      if (this.showPlatform) {
        this.showPlatform = false;
      }
    },
    handlePlatform(info) {
      this.platformName = info.text;
      this.platformId = info.id;
    },
    handleServer(info) {
      this.serverName = info.text;
      this.serverId = info.id;
    },
    handleOpenServer() {
      this.showServer = !this.showServer;
    },
    handleServerClickOutside() {
      if (this.showServer) {
        this.showServer = false;
      }
    },
    handleRole(info) {
      this.roleName = info.text;
      this.roleId = info.id;
    },
    handleOpenRole() {
      this.showRole = !this.showRole;
    },
    handleRoleClickOutside() {
      if (this.showRole) {
        this.showRole = false;
      }
    },
    handleBuy() {
      if (
        this.platformId !== -1 &&
        this.serverId !== -1 &&
        this.roleId !== -1
      ) {
        this.showPayTypeChoose = true;
      } else {
        alert("请选择完整信息");
      }
    },
    closePayTypeChoose() {
      console.log(this.showPayTypeChoose);

      if (this.showPayTypeChoose) {
        this.showPayTypeChoose = false;
      }
    },
    handleAddCart() {
      this.isAddCart = !this.isAddCart;
    },
  },
  mounted() {
    this.$parent.getlan();
  },
};
</script>

<style scoped>
.product {
  width: 50%;
  min-width: 50%;
  margin: auto;
  box-sizing: border-box;
  padding-top: 3%;
}
.product-list {
  padding: 2%;
  background-color: white;
}
.product-list:nth-of-type(1) {
  margin-bottom: 2%;
}
.title {
  font-size: 20px;
  font-weight: 600;
  color: #57749c;
  padding: 2% 3%;
  border-bottom: 1px solid #57749c;
}
.product-banner {
  padding: 2%;
}
.product-banner img {
  width: 100%;
  display: block;
}
.product-text {
  font-size: 16px;
  word-break: break-all;
}
.product-download {
  background-color: #e7ebf1;
  padding: 1.5% 2%;
  margin-top: 1%;
}
.product-download .download-title {
  color: #5b6e88;
  font-size: 20px;
  text-align: center;
  background-color: white;
  padding: 1% 0;
  font-weight: 600;
}
.download-box {
  font-size: 20px;
  text-align: center;
  padding: 1% 0 0;
}
.download-box a {
  display: inline-block;
  cursor: pointer;
  width: 15%;
  margin: 1% 1% 0;
}
.download-box a img {
  width: 100%;
  display: block;
}
.top-header {
  display: flex;
}
.left-div {
  width: 40%;
  position: relative;
  font-size: 0;
}
.left-1 {
  /* height: 100%; */
  display: inline-block;
  vertical-align: middle;
}
.left-1 img {
  display: block;
  margin: auto;
}
.left-1 img:nth-last-of-type(2) {
  margin: 15px 0;
}
.left-1 img:nth-last-of-type(1) {
  margin-top: 8vh;
}
.left-2 {
  width: 70%;
  display: inline-block;
  margin-left: 5%;
}
.right-div {
  width: 60%;
}
.right-div h2 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
}
.right-div p {
  font-size: 14px;
}
.sj-div {
  padding: 10px 0;
  border-top: 1px solid #e2e2e2;
  border-bottom: 1px solid #e2e2e2;
  margin: 5px 0;
}
.sj-div p {
  background-color: #f6f6f6;
  padding: 4px;
}
.sj-div span {
  color: #c83737;
  font-size: 18px;
  margin-left: 15px;
}
.list-div {
  display: flex;
  margin-top: 5%;
}
.list-div p {
  width: 20%;
}
.lists {
  font-size: 0;
  width: 80%;
}
.lists span {
  border: solid 1px rgba(206, 206, 206, 0.83);
  font-size: 14px;
  background-color: #f6f6f6;
  padding: 3px 10px;
  cursor: pointer;
  display: inline-block;
  min-width: 30%;
  text-align: center;
  box-sizing: border-box;
  margin: 0 12px 10px 0;
}
.lists span.active {
  border: solid 1px rgba(200, 55, 55, 0.83);
}
.lists-num {
  font-size: 0;
  border: solid 1px rgba(206, 206, 206, 0.83);
  display: flex;
  text-align: center;
  align-items: center;
  background-color: #f6f6f6;
  width: 25%;
  position: relative;
  cursor: pointer;
}
.lists-num span {
  min-width: auto;
  display: inline-block;
  border: none;
  margin: 0;
  background-color: #f6f6f6;
  padding: 3px 10px;
  cursor: pointer;
}
.lists-num span:last-child {
  float: right;
}
.lists-num p {
  display: inline-block;
  text-align: center;
  font-size: 14px;
  padding: 3px 0px;
  background-color: white;
  width: 80%;
}
.list-box {
  position: absolute;
  left: -1px;
  top: 100%;
  z-index: 1;
  width: 100%;
  text-align: center;
  font-size: 14px;
  border: solid 1px rgba(206, 206, 206, 0.83);
  background-color: #ffffff;
}
.list {
  padding: 3px 0px;
  border-bottom: solid 1px rgba(206, 206, 206, 0.83);
  cursor: pointer;
}
.list.active {
  background-color: #cccccc;
}
.list:last-child {
  border-bottom: none;
}
.but-div {
  margin-top: 5%;
  border-top: solid 1px rgba(206, 206, 206, 0.83);
  padding-top: 5%;
  font-size: 0;
  display: flex;
}
.but-box,
.but-box2 {
  font-size: 18px;
  color: white;
  background-color: #ed3029;
  display: inline-block;
  padding: 2% 5%;
  text-align: center;
  cursor: pointer;
}
.but-box2 {
  margin-left: 5%;
  background-color: #1da3fb;
}
.but-box2.active {
  background-color: #00243b;
}
.product-text-div {
  padding: 0 5%;
}
.title-box {
  margin-top: 5%;
  font-size: 20px;
  padding: 3px 5%;
  background-color: #797979;
  color: white;
}
.text-div-list {
  display: flex;
  margin-top: 5%;
}
.text-div-list span {
  display: block;
  text-align: center;
}
.text-div-list span em {
  background-color: #c8443f;
  padding: 2px 5px;
  color: white;
  display: block;
}
.text-div-list p {
  width: 70%;
  margin-left: 3%;
}
.img {
  max-width: 100%;
  margin-top: 5%;
}
@media screen and (max-width: 1000px) {
  .product {
    width: 95%;
  }
  .product-list {
    padding: 2% 2% 3%;
    background-color: white;
  }
  .product-list:nth-of-type(1) {
    margin-bottom: 3%;
  }
  .product-download {
    padding: 3%;
  }
  .download-box a {
    margin: 3% 3% 0;
    width: 34%;
  }
  .left-1 img:nth-last-of-type(1) {
    margin-top: 0;
  }
  .left-2 {
    width: 70%;
  }
  .list-div p {
    width: 40%;
  }
  .lists {
    width: 50%;
  }
  .lists-num {
    width: 50%;
  }
  .lists-num p {
    width: 80%;
  }
  .but-box,
  .but-box2 {
    font-size: 16px;
  }
  .text-div-list span em {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/yxsc.vue